import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isAuth = this.authService.getIsAuth();
    const userRole = this.authService.getUserRole();
    const roles = route.data.roles as Array<string>;
    console.log('Auth guard');
    console.log('Auth guard isAuth: ', isAuth);
    console.log('Auth guard userRole: ', userRole);
    console.log('Auth guard roles: ', roles);
    if (!isAuth) {
      this.router.navigate(['/iniciar-sesion']);
    }
    if (roles && roles.indexOf(userRole) === -1) {
      //alert('No tiene permisos para acceder a esta página.');
      this.authService.logout(
        'Para poder acceder a esta página, por favor, inicie sesión.'
      );
      return false;
    }
    return isAuth;
  }
}
